import React, { FC, useState } from 'react';
import s from './preview.module.scss';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import dynamic from 'next/dynamic';
import { model3d } from '@specs/specs';
import { generateToyModelPath } from '@services/toys/helpers';
import { gtagEventTrigger } from '@specs/helpers';
const Modal = dynamic(import('@components/Modals/Modal').then(module => module.Modal), {
  ssr: false
});
const ArUnavailable = dynamic(import('@components/Modals/Variants/ArUnavailable/ArUnavailable').then(module => module.ArUnavailable), {
  ssr: false
});
const ViewAr = dynamic(import('@components/Modals/Variants/ViewAr/ViewAr').then(module => module.ViewAr), {
  ssr: false
});
interface Props {
  canScanQR: boolean;
  showModelViewer: boolean;
  model: model3d | null | undefined;
}
export const PreviewAr: FC<Props> = ({
  canScanQR,
  showModelViewer,
  model
}) => {
  const [modalVariant, setModalVariant] = useState<'ArUnavailable' | 'ViewAr' | undefined>(undefined);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const closeHandler = () => {
    setIsOpenModal(false);
  };
  const clickHandler: React.MouseEventHandler<HTMLAnchorElement> = e => {
    gtagEventTrigger({
      action: 'click_ar_desktop',
      category: 'action'
    });
    if (!showModelViewer) {
      e.preventDefault();
      setModalVariant('ArUnavailable');
      setIsOpenModal(true);
    } else {
      if (!model) return e.preventDefault();
      if (canScanQR) return;
      e.preventDefault();
      setModalVariant('ViewAr');
      setIsOpenModal(true);
    }
  };
  const isAndroid = typeof window === 'undefined' ? false : new RegExp('android', 'i').test(navigator.userAgent.toLowerCase());
  const {
    usdz,
    glb
  } = generateToyModelPath(model);
  const href = !isAndroid ? usdz : `intent://arvr.google.com/scene-viewer/1.0?mode=ar_preferred&disable_occlusion=true&file=${encodeURI(glb)}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${process.env.NEXT_PUBLIC_BASE_URL};end;`;
  return <>
            <a className={s.preview__icon} referrerPolicy='strict-origin' href={href} onClick={clickHandler}
    // ar обязательный! Иначе на яблоках открытие происходит не перманентно
    rel={'ar'}>
                {/*пустой img обязательный! Иначе на яблоках открытие происходит не перманентно*/}
                <img alt='' />
                <SpriteIcon name={showModelViewer ? 'ar_available' : 'ar_lock'} width={40} height={40} color={'--Thamar-Black'} data-sentry-element="SpriteIcon" data-sentry-source-file="PreviewAr.tsx" />
            </a>
            <Modal isOpen={isOpenModal} onClose={closeHandler} onAfterClose={() => {
      setModalVariant(undefined);
    }} data-sentry-element="Modal" data-sentry-source-file="PreviewAr.tsx">
                {modalVariant === 'ArUnavailable' && <ArUnavailable closeHandler={closeHandler} />}
                {modalVariant === 'ViewAr' && <ViewAr closeHandler={closeHandler} />}
            </Modal>
        </>;
};